import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import mutations from './mutations'
import state from './state'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  plugins: [
    createPersistedState({
      key: 'cguardian' // 自定义持久化key值，避免和其他项目重复，api：https://github.com/robinvdvleuten/vuex-persistedstate
    })
  ]
})
